import AxiosInstance, { ACCOUNT_HEADER_KEY, AUTH_HEADER_KEY, SPACE_HEADER_KEY } from "../utils/axios.js"

/*****  Auth Starts  *****/
export const authStore = async ({ shop, code, scope, host }) => {
    return AxiosInstance.get(`/auth/auth-store?shop=${shop}&code=${code}&scope=${scope}&host=${host}`)
}

export const getUser = async (token) => {
    return AxiosInstance.get('/auth/user', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getUserAccountsByJwt = async (token) => {
    return AxiosInstance.get('/auth/user/account', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getSpacesByJwt = async (token) => {
    return AxiosInstance.get('/auth/user/space', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const getSpacesOfUser = async (token) => {
    return AxiosInstance.get('/auth/space', { headers: { [AUTH_HEADER_KEY]: token } })
}

export const inviteUserToAccount = async ({ emailToInvite, urlToAcceptInvitation, role }) => {
    return AxiosInstance.post('/auth/account/user/invite', { emailToInvite, urlToAcceptInvitation, role })
}

export const getInvitationData = async (inviteeToken) => {
    return AxiosInstance.get(`/auth/user/invitation?inviteeToken=${inviteeToken}`)
}

export const registerUser = async (userData) => {
    return AxiosInstance.post('/auth/user', userData)
}

export const logInUser = async ({ email, password }) => {
    return AxiosInstance.post('/auth/user/login', { email, password })
}

export const acceptInvitation = async ({ inviteeToken, userId }) => {
    return AxiosInstance.post('/auth/user/accept-invitation', { inviteeToken, userId })
}

export const authUser = async ({ email, password, name }) => {
    return AxiosInstance.post('/auth/user/register', { email, password, name })
}

export const updateUser = async (userId, { email, name, profileImage }) => {
    return AxiosInstance.put(`/auth/user/${userId}`, { email, name, profileImage })
}

export const updateUserPassword = async ({ userId, oldPassword, newPassword }) => {
    return AxiosInstance.post('/auth/user/password', { userId, oldPassword, newPassword })
}

export const updateAccount = async (accountId, { name, email, users, shouldInitializeResearch }) => {
    return AxiosInstance.put(`/auth/account/${accountId}`, { name, email, users, shouldInitializeResearch })
}

export const updateSpace = async (spaceId, spaceData) => {
    return AxiosInstance.put(`/auth/space/${spaceId}`, spaceData)
}

export const getSpaceUsers = async (spaceId) => {
    return AxiosInstance.get(`/auth/space/users?spaceId=${spaceId}`)
}

export const createSpace = async (spaceData) => {
    return AxiosInstance.post('/auth/space', spaceData)
}

export const deleteSpace = async (spaceId) => {
    return AxiosInstance.delete(`/auth/space/${spaceId}`)
}

export const deleteSpaceMember = async (spaceId, userId) => {
    return AxiosInstance.delete(`/auth/space/${spaceId}/user/${userId}`)
}

export const assignUserToSpace = async (spaceId, userData) => {
    return AxiosInstance.post(`/auth/space/${spaceId}/user`, userData)
}

export const removeUserFromSpace = async (spaceId, userData) => {
    return AxiosInstance.post(`/auth/space/${spaceId}/user/remove`, userData)
}

export const getAccountUsers = async () => {
    return AxiosInstance.get(`/auth/account/users`)
}

export const removeUserFromAccount = async (userData) => {
    return AxiosInstance.post(`/auth/account/user/remove`, userData)
}

// userId, oldPassword, newPassword
/*****  Auth Ends  *****/


/*****  EconProvider Starts  *****/
export const searchProductsByTitle = async (title) => {
    return AxiosInstance.get(`/ecom-provider/products/search?title=${title}`)
}
/*****  EconProvider Ends  *****/


/*****  Integrations Starts  *****/
export const connectToKlaviyo = async (authData, accountId) => {
    return AxiosInstance.post(`/integrations/klaviyo/connect`, authData, { headers: { [ACCOUNT_HEADER_KEY]: accountId } })
}

export const connectToGoogle = async (authData, accountId) => {
    return AxiosInstance.post(`/integrations/google/connect`, authData, { headers: { [ACCOUNT_HEADER_KEY]: accountId } })
}

export const generateKlaviyoCodes = async () => {
    return AxiosInstance.get('/integrations/klaviyo/codes')
}

export const finishMetaOauthFlow = async (integrationData) => {
    return AxiosInstance.post('/integrations/meta/connect', integrationData)
}

export const generateMetaReport = async (integration, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement }) => {
    return AxiosInstance.post(`/integrations/meta/ads-report-insights?integration=${integration}`, { adAccountId, sinceDate, untilDate, filters, breakdowns, daysToSplitIncrement })
}

export const getMetaAdInsights = async ({ integration, adId, sinceDate, untilDate, breakdownType, daysToSplitIncrement }) => {
    let url = `/integrations/meta/ad-insights?integration=${integration}&adId=${adId}`
    if (sinceDate) {
        url += `&sinceDate=${sinceDate}`
    }
    if (untilDate) {
        url += `&untilDate=${untilDate}`
    }
    if (breakdownType) {
        url += `&breakdownType=${breakdownType}`
    }

    if (daysToSplitIncrement) {
        url += `&daysToSplitIncrement=${daysToSplitIncrement}`
    }

    return AxiosInstance.get(url)
}

export const getMetaSyncJobs = async () => {
    return AxiosInstance.get(`/integrations/jobs`)
}

export const triggerMetaSyncJob = async (integration, adAccountId) => {
    return AxiosInstance.post(`/integrations/meta/trigger-sync-ad-account-data?integration=${integration}&adAccountId=${adAccountId}`)
}

export const updateIntegration = async (integrationId, integrationData) => {
    return AxiosInstance.put(`/integrations/${integrationId}`, integrationData)
}

export const checkFb = async (data) => {
    return AxiosInstance.post(`/integrations/check-fb`, data)
}

export const getIntegrations = async () => {
    return AxiosInstance.get('/integrations/all')
}

export const getKlaviyoTemplateById = async (templateId, integration) => {
    return AxiosInstance.get(`/integrations/klaviyo/template/${templateId}?integration=${integration}`)
}

export const updateKlaviyoTemplateById = async (templateId, templateData) => {
    return AxiosInstance.put(`/integrations/klaviyo/template/${templateId}`, templateData)
}

export const createKlaviyoTemplate = async (templateData) => {
    return AxiosInstance.post(`integrations/klaviyo/template`, templateData)
}

export const createKlaviyoCampaign = async (campaignData, integration) => {
    return AxiosInstance.post(`integrations/klaviyo/campaign/full-flow?integration=${integration}`, campaignData)
}

export const updateKlaviyoCampaign = async (campaignData, campaignId, integration) => {
    return AxiosInstance.put(`integrations/klaviyo/campaign/${campaignId}/full-flow?integration=${integration}`, campaignData)
}

export const getKlaviyoCustomerLists = async (integration) => {
    return AxiosInstance.get(`integrations/klaviyo/list?integration=${integration}`)
}

export const getKlaviyoAccounts = async (integration) => {
    return AxiosInstance.get(`integrations/klaviyo/accounts?integration=${integration}`)
}

export const deleteKlaviyoCampaign = async (integration, campaignId) => {
    return AxiosInstance.delete(`/integrations/klaviyo/campaign/${campaignId}?integration=${integration}`)
}

export const updateKlaviyoSendJob = async (integration, sendJobId) => {
    return AxiosInstance.put(`integrations/klaviyo/campaign/send-job/${sendJobId}?integration=${integration}`)
}

export const connectShopify = async (authData, accountId, jwt) => {
    return AxiosInstance.post(`/integrations/shopify/connect`, authData, { headers: { [ACCOUNT_HEADER_KEY]: accountId, [AUTH_HEADER_KEY]: jwt } })
}

export const getAccountByShopifyDomain = async (shopDomain) => {
    return AxiosInstance.get(`/integrations/shopify/account?shopDomain=${shopDomain}`)
}

export const getStoreCompetitors = async (integrationId, ignoreCache) => {
    let url = `/integrations/shopify/competitors?integrationId=${integrationId}`
    if (ignoreCache) {
        url += `&ignoreCache=${ignoreCache}`
    }
    return AxiosInstance.get(url)
}

export const getShopifyProducts = async (title) => {
    let url = `/integrations/shopify/products`
    if (title) {
        url += `?title=${title}`
    }
    return AxiosInstance.get(url)
}

/*****  Integrations Ends  *****/

/***** Creative Starts *****/
export const getCreatives = async (addAccountId) => {
    let url = '/creative'
    if (addAccountId) {
        url += `?adAccountId=${addAccountId}`
    }
    return AxiosInstance.get(url)
}

export const getManyCreativesById = async (creativeIds) => {
    return AxiosInstance.post('/creatives/many', { creativeIds })
}

export const getCreativeAsyncAnalyzeJobStatus = async () => {
    return AxiosInstance.get(`/creative/async-analyze/status`)
}

export const getCreativeById = async (creativeId) => {
    return AxiosInstance.get(`/creative/${creativeId}`)
}

export const getFolders = async () => {
    return AxiosInstance.get('creative/folder')
}

export const createFolder = async (folderData) => {
    return AxiosInstance.post('creative/folder', folderData)
}

export const deleteFolder = async (folderId) => {
    return AxiosInstance.delete(`/creative/folder/${folderId}`)
}

export const updateFolder = async (folderId, folderData) => {
    return AxiosInstance.put(`/creative/folder/${folderId}`, folderData)
}

export const deleteCreative = async (creativeId) => {
    return AxiosInstance.delete(`creative/${creativeId}`)
}

export const updateCreatives = async (creativeId, creativeData) => {
    return AxiosInstance.put(`creative/${creativeId}`, creativeData)
}

export const getAdvertisers = async (facebookUrl) => {
    let url = '/creative/advertiser'
    if (facebookUrl) {
        url += `?facebookUrl=${facebookUrl}`
    }
    return AxiosInstance.get(url)
}

export const generateExternalAdTranscript = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/generate-transcript`, { externalAdId })
}

export const generateExternalAdBrief = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/generate-brief`, { externalAdId })
}

export const generateExternalAdCustomTranscript = async ({ externalAdId, targetEntityName, description }) => {
    return AxiosInstance.post(`/creative/external-ad/generate-custom-transcript`, { externalAdId, targetEntityName, description })
}

export const deleteExternalAdCustomTranscript = async (externalAdId) => {
    return AxiosInstance.delete(`/creative/external-ad/generate-custom-transcript/${externalAdId}`)
}

export const updateExternalAd = async (externalAdId, externalAdData) => {
    return AxiosInstance.put(`/creative/external-ad/${externalAdId}`, externalAdData)
}

export const generateExternalAdCreativeConcept = async ({ externalAdId, userContext }) => {
    return AxiosInstance.post(`/creative/external-ad/generate-concept`, { externalAdId, userContext })
}

export const deleteExternalAdCreativeConcept = async (externalAdId) => {
    return AxiosInstance.post(`/creative/external-ad/delete-creative-concept`, { externalAdId })
}

export const getExternalAdCreativeConcept = async (externalAdId) => {
    return AxiosInstance.get(`/creative/external-ad/creative-concept?externalAdId=${externalAdId}`)
}

export const getAdvertiserAds = async (advertiserId) => {
    return AxiosInstance.get(`creative/advertiser/ads?advertiserId=${advertiserId}`)
}

export const followAdvertiser = async (advertiserId) => {
    return AxiosInstance.post(`creative/advertiser-space`, { advertiserId })
}

export const followAdvertiserWithSpace = async (advertiserId, spaceId) => {
    return AxiosInstance.post(`creative/advertiser-space`, { advertiserId }, { headers: { [SPACE_HEADER_KEY]: spaceId } })
}

export const unfollowAdvertiser = async (advertiserId) => {
    return AxiosInstance.post(`creative/remove-advertiser-space?advertiserId=${advertiserId}`)
}

export const analyzeAdvertiserCreativeStrategy = async (advertiserId, ignoreCache) => {
    return AxiosInstance.post(`creative/advertiser/analyze-strategy`, { advertiserId, ignoreCache })
}

export const analyzeAdvertiserCreativeStrategyCustomQuery = async (advertiserId, query) => {
    return AxiosInstance.post(`creative/advertiser/analyze-strategy-custom-query`, { advertiserId, query })
}

export const generateBrandStrategySnapshot = async (data) => {
    return AxiosInstance.post(`/creative/brand/strategy/snapshot`, data)
}

export const getBrandStrategySnapshot = async (snapshotId) => {
    return AxiosInstance.get(`/creative/brand/strategy/snapshot/${snapshotId}`)
}

export const getCreativeReports = async () => {
    return AxiosInstance.get('creative/report')
}

export const createCreativeReport = async (createReportData) => {
    return AxiosInstance.post('creative/report', createReportData)
}

export const updateCreativeReport = async (reportId, createReportData) => {
    return AxiosInstance.put(`creative/report/${reportId}`, createReportData)
}

export const deleteCreativeReport = async (reportId) => {
    return AxiosInstance.delete(`creative/report/${reportId}`)
}

export const generateSnapshot = async (snapshotData) => {
    return AxiosInstance.post(`/creative/snapshot`, snapshotData)
}

export const getPublicSnapshot = async (snapshotId) => {
    return AxiosInstance.get(`/creative/snapshot/${snapshotId}`)
}

export const updateCreative = async (creativeId, creativeData) => {
    return AxiosInstance.put(`/creative/${creativeId}`, creativeData)
}

export const analyzeCreativeLabelsAndProperties = async (creativeId) => {
    return AxiosInstance.post(`/creative/analyze`, { creativeId })
}

export const analyzeCreativeLabels = async (creativeId) => {
    return AxiosInstance.post(`/creative/analyze-labels`, { creativeId })
}

export const analyzeCreativeProperties = async (creativeId) => {
    return AxiosInstance.post(`/creative/analyze-properties`, { creativeId })
}

// Should be remove soon
export const analyzeMultiCreativesInsights = async (creativesId) => {
    return AxiosInstance.post(`/creative/analyze-creatives-insights`, { creativesId })
}

export const getExternalAdForPublicView = async (externalAdId, spaceId) => {
    return AxiosInstance.get(`/creative/external-ad/public/${externalAdId}?spaceId=${spaceId}`)
}

// New version
export const generateCreativeInsights = async ({ creativeIds, deepDive }) => {
    return AxiosInstance.post(`/creative/creative-insights`, { creativeIds, deepDive })
}

export const suggestSuperSegments = async ({ creativeIds }) => {
    return AxiosInstance.post(`/creative/generate-super-segments`, { creativeIds })
}

export const getExternalAdsForDiscovery = async () => {
    return AxiosInstance.get(`/creative/external-ad/random`)
}

export const semanticSearchExternalAds = async (query) => {
    return AxiosInstance.post(`/creative/external-ad/semantic-search`, { query })
}

export const semanticSearchByDescriptorsExternalAds = async ({ externalAdIds, advertiserIds, query, threshold }) => {
    return AxiosInstance.post(`/creative/external-ad/semantic-search-descriptors`, { externalAdIds, advertiserIds, query, threshold })
}

export const getManyExternalAdsById = async (externalAdIds) => {
    return AxiosInstance.get(`/creative/external-ad/many-by-id?externalAdIds=${externalAdIds.join(',')}`)
}

export const searchExternalAdsByConcept = async ({ concepts, advertiserId }) => {
    return AxiosInstance.post(`/creative/external-ad/search-by-concept`, { concepts, advertiserId })
}

export const createBoard = async (boardData) => {
    return AxiosInstance.post(`/creative/external-ad/board`, boardData)
}

export const getBoardsOfSpace = async () => {
    return AxiosInstance.get(`/creative/external-ad/board`)
}

export const updateBoard = async ({ boardId, boardData }) => {
    return AxiosInstance.put(`/creative/external-ad/board/${boardId}`, boardData)
}

export const deleteBoard = async ({ boardId }) => {
    return AxiosInstance.delete(`/creative/external-ad/board/${boardId}`)
}

export const searchExternalAdsByFilters = async ({ filters, advertiserIds }) => {
    return AxiosInstance.post(`/creative/external-ad/search-by-filters`, { filters, advertiserIds })
}


// ------ should remove soon
export const filterCreativesByUserQuery = async ({ creativeIds, query }) => {
    return AxiosInstance.post(`/creative/filter-creatives-by-user-query`, { creativeIds, query })
}

export const semanticSearchCreatives = async ({ creativeIds, query, threshold, minStartOffsetSec, maxEndOffsetSec, ignoreCache }) => {
    // return AxiosInstance.post(`/creative/semantic-search`, { creativeIds, query, minStartOffsetSec, maxEndOffsetSec, ignoreCache })
    return AxiosInstance.post(`/creative/search-by-descriptors-semantic`, { creativeIds, query, threshold, minStartOffsetSec, maxEndOffsetSec, ignoreCache })
}

export const compareSemanticSearchCreatives = async ({ creativeIds, queries, threshold, ignoreCache }) => {
    // return AxiosInstance.post(`/creative/semantic-search-compare`, { creativeIds, queries, ignoreCache })
    return AxiosInstance.post(`/creative/search-by-descriptors-semantic-compare`, { creativeIds, queries, threshold, ignoreCache })
}

export const compareCreatives = async ({ targetCreativeId, creativeIdsToCompare, targetAdMetrics, adsToCompareMetrics }) => {
    return AxiosInstance.post(`/creative/creative-comparison`, { targetCreativeId, creativeIdsToCompare, targetAdMetrics, adsToCompareMetrics })
}

/***** Creative Ends *****/

/***** Web Quest Starts *****/
export const getPageByUrl = async (pageUrl) => {
    // return AxiosInstance.get(`/web-quest/page?pageUrl=${pageUrl}`) // OLD - using Apify
    return AxiosInstance.get(`/web-quest/facebook-page?pageUrl=${pageUrl}`)
}

export const getPageJob = async (pageId) => {
    return AxiosInstance.get(`/web-quest/job?pageId=${pageId}`)
}

export const triggerPublicAdsProcess = async (pageId) => {
    return AxiosInstance.get(`/web-quest/public-ads?pageId=${pageId}`)
}

export const getMetaVideo = async (videoUrl) => {
    return AxiosInstance.get(`/web-quest/video?videoUrl=${videoUrl}`)
}

// web-quest/facebook-page-url
export const getFacebookPageUrl = async (websiteUrl) => {
    return AxiosInstance.get(`/web-quest/facebook-page-url?websiteUrl=${websiteUrl}`)
}

/***** Web Quest Ends *****/

/***** Payments *****/
export const getPlans = async () => {
    return AxiosInstance.get(`/payments/plan`)
}

export const getSubscriptionOfAccount = async () => {
    return AxiosInstance.get(`payments/subscription/account`)
}

export const cancelSubscription = async (subscriptionId) => {
    return AxiosInstance.post(`payments/subscription/cancel`, { subscriptionId })
}

export const initShopifyCheckout = async ({ planId, callbackUrl, billingCycle }) => {
    return AxiosInstance.post(`payments/subscription/shopify/initialize-checkout`, { planId, callbackUrl, billingCycle })
}

export const verifyShopifyPayment = async (shopDomain) => {
    return AxiosInstance.get(`payments/subscription/shopify/verify-subscription?shopDomain=${shopDomain}`)
}

/***** Payments Ends *****/
